<template>
    <div>
        <Loader v-show="loading" />
        <div v-show="!loading" class="container-fluid mt-45">
            <div class="row">
                <div class="col-md-6">
                    <Breadcrumbs />
                </div>

                <div class="col-md-6 d-flex align-items-center justify-content-end">
                    <div v-if="tokenExpirySeconds != null && tokenExpirySeconds > 0">
                        <p class="font-weight-bold mb-0">Time remaining {{ tokenExpirySeconds | moment('mm:ss') }} <img id="tooltip-target" class="ml-1" src="@/assets/images/icons/tooltip.svg" width="21" height="21"></p>
                        <b-tooltip target="tooltip-target" triggers="hover">
                            <div class="p-3">
                                <div class="d-flex align-items-center">
                                    <img src="@/assets/images/icons/time-icon.svg" width="21" height="21" />
                                    <div style="font-size: 1.1rem" class="ml-2">What's this?</div>
                                </div>
                                <div class="d-flex justify-content-start text-left mt-2">
                                    This timer indicates how long your session will remain active to assign the device. If it expires, you'll be redirected to the dashboard, and the assignment process will need to be repeated
                                </div>
                            </div>
                        </b-tooltip>
                    </div>

                    <button @click="cancelTest()" class="btn btn-danger btn-cancel-test btn-block-mobile btn-lg lg-shadow ml-2 mt-4 mt-md-0">Cancel test</button>
                </div>
            </div>

            <div class="row justify-content-center mt-5">
                <div class="col-md-6">                    
                    <div class="card card-body p-5 border-0 shadow">
                        <div class="row justify-content-between">
                            <div class="col-lg-7">
                                <h1 class="mb-4">Scan QR Code</h1>
                                <p class="h2">Open camera on your phone and scan the QR code</p>

                                <div class="alert alert-warning border d-flex p-2 mb-0 mt-5">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="19" viewBox="0 0 22 19">
                                            <defs>
                                                <linearGradient id="linear-gradient" x1="0.384" y1="0.263" x2="0.887" y2="0.928" gradientUnits="objectBoundingBox">
                                                    <stop offset="0" stop-color="#e8c400"/>
                                                    <stop offset="1" stop-color="#d5b400"/>
                                                </linearGradient>
                                            </defs>
                                            <g id="Group_375" data-name="Group 375" transform="translate(-0.5)">
                                                <g id="Group_261" data-name="Group 261">
                                                <g id="Group_267" data-name="Group 267" transform="translate(6.783 5.256)">
                                                    <path id="Path_5992" data-name="Path 5992" d="M709.117,408.531l-6.906-6.906,1.7-1.7,6.906,6.906Z" transform="translate(-702.211 -399.926)" fill="#fff"/>
                                                    <path id="Path_5993" data-name="Path 5993" d="M703.91,408.531l-1.7-1.7,6.906-6.906,1.7,1.7Z" transform="translate(-702.211 -399.926)" fill="#fff"/>
                                                </g>
                                                <g id="Group_274" data-name="Group 274" transform="translate(0)">
                                                    <g id="Polygon_1" data-name="Polygon 1" transform="translate(0.5)" stroke-linecap="round" fill="url(#linear-gradient)">
                                                    <path d="M 20.26555061340332 18.50000190734863 L 1.734450936317444 18.50000190734863 C 1.473720908164978 18.50000190734863 1.344671010971069 18.32499122619629 1.301290988922119 18.24974060058594 C 1.257900953292847 18.17450141906738 1.171100974082947 17.97512054443359 1.301741003990173 17.74947166442871 L 10.56728076934814 1.745351076126099 C 10.69765090942383 1.520171046257019 10.91332054138184 1.495861053466797 11.00000095367432 1.495861053466797 C 11.08667087554932 1.495861053466797 11.30234050750732 1.520171046257019 11.43270111083984 1.745341062545776 L 20.69827079772949 17.74948120117188 C 20.82890129089355 17.97512054443359 20.74210166931152 18.17449188232422 20.69871139526367 18.24974060058594 C 20.65533065795898 18.32499122619629 20.52627182006836 18.50000190734863 20.26555061340332 18.50000190734863 Z" stroke="none"/>
                                                    <path d="M 10.99999141693115 1.995851516723633 L 11.00000190734863 1.995870590209961 C 11.00000190734863 1.995870590209961 11.00000095367432 1.995870590209961 11.00000095367432 1.995870590209961 L 1.734451293945312 17.99999046325684 C 1.73444938659668 17.9999942779541 1.734447479248047 17.99999809265137 1.734445571899414 18.00000190734863 C 1.734447479248047 18.00000190734863 1.73444938659668 18.00000190734863 1.734451293945312 18.00000190734863 L 20.26555061340332 18.00000190734863 L 10.99999141693115 1.995851516723633 M 11 0.9958629608154297 C 11.33642101287842 0.9958629608154297 11.67284107208252 1.162185668945312 11.86542129516602 1.494831085205078 L 21.1309814453125 17.49896049499512 C 21.51694107055664 18.16563034057617 21.03588104248047 19.00000190734863 20.26555061340332 19.00000190734863 L 1.734451293945312 19.00000190734863 C 0.964111328125 19.00000190734863 0.4830608367919922 18.16563034057617 0.8690204620361328 17.49896049499512 L 10.13457107543945 1.494831085205078 C 10.32715606689453 1.162185668945312 10.66357803344727 0.9958629608154297 11 0.9958629608154297 Z" stroke="none" fill="#cfb000"/>
                                                    </g>
                                                    <g id="Group_273" data-name="Group 273" transform="translate(10.426 6.832)">
                                                    <path id="Path_5994" data-name="Path 5994" d="M.021,0l.5,6.148H1.65L2.122,0Z" transform="translate(0.002 0)" fill="#fff"/>
                                                    <path id="Path_5995" data-name="Path 5995" d="M1.075,8.145a1.1,1.1,0,0,0,.781-.266.935.935,0,0,0,.289-.72.94.94,0,0,0-.289-.729,1.116,1.116,0,0,0-.781-.262A1.126,1.126,0,0,0,.29,6.43.936.936,0,0,0,0,7.159a.923.923,0,0,0,.288.72,1.116,1.116,0,0,0,.785.266" transform="translate(-0.001 0.62)" fill="#fff"/>
                                                    </g>
                                                </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="pl-3">
                                        <p class="text-sm mb-0">This screen will automatically update.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 text-center">
                                <canvas id="canvas"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import Loader from '@/partials/Loader'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
import SignalRMixin from '@/mixins/SignalRMixin'
import SessionExpiredModal from '@/components/modals/SessionExpiredModalComponent'
import ConnectionDiagnosticsModal from '@/components/modals/ConnectionDiagnosticsModalComponent'

export default {
    name: 'AssignToken',

    mixins: [
        SignalRMixin
    ],

    components: {
        Loader,
        Breadcrumbs
    },

    data() {
        return {
            loading: true,
            CancelTestModalComponent,
            SessionExpiredModal
        }
    },

    watch: {
        tokenExpirySeconds: function(val) {
            if(val != null && val <= 0) {
                this.$modal.show(SessionExpiredModal, {}, {width: '400px'})
                return this.$router.push({name: 'TestDetails'})
            } 
        }
    },

    mounted() {
        if(!this.isSignalRConnected()) return this.$router.push({name: 'Dashboard'})
        
        try {
            this.getTokenExpiry()
            var qrcode = require('qrcode')
            var canvas = document.getElementById('canvas')

            qrcode.toCanvas(canvas, `${process.env.VUE_APP_ASSIGN_URL}?token=${this.token}`, { width: 200 }, function(error) {
                if (error) throw new Error()
            })

            this.bindConnectionMessage(this.signalRConnection)
            this.loading = false
        } catch {
            this.setNotification({
                type: 'error',
                title: 'Error',
                message: 'Something went wrong. Please try again.'
            })
            return this.$router.push({name: 'Dashboard'})
        }
    },

    methods: {
        ...mapActions({
            setNotification: 'NotificationStore/SetNotification',
        }),

        cancelTest() {
            this.$modal.show(CancelTestModalComponent, {}, {width: '400px'});
        },

        bindConnectionMessage(connection) {
            var beginAssignmentCallback = function (tokenDetails) {
                this.setTokenResponse(tokenDetails)
                this.$router.push({name: 'AssignTestKit'})
            }.bind(this)

            var hcpAssignmentTokenErrorCallback = function (tokenDetails) {
                this.setTokenResponse(tokenDetails)
            }.bind(this)

            connection.on("beginAssignment", beginAssignmentCallback)
            connection.on("hcpAssignmentTokenError", hcpAssignmentTokenErrorCallback)
        },

        // The connection died while waiting for the device scan; the user retries from
        // TestDetails (mirrors the session-expiry flow above).
        onSignalRConnectionLost() {
            this.$modal.show(ConnectionDiagnosticsModal, {}, {width: '600px'})
            if(this.$route.name !== 'TestDetails') this.$router.push({name: 'TestDetails'})
        }
    },

    beforeDestroy() {
        this.stopTokenExpiryCountdown()
    }
}
</script>